import ConsentInner from './ConsentInner';

const ConsentGov = () => {
  return <ConsentInner variant="microsoft365-us" />;
};

export default ConsentGov;
